import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/166/components/features/cases/OldComponents/cases/zkhfoundation/index.js");
